import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faBookmark,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import {
  faHeart as faHeartRegular,
  faBookmark as faBookmarkRegular,
} from "@fortawesome/free-regular-svg-icons";
import { Icon } from "@iconify/react";
import api from "../../api/axios";
import styles from "./PostFooter.module.css";
import { useNavigate } from "react-router-dom";
import UserListModel from "../model/UserListModel";

const PostFooter = ({
  post,
  feedType = "PUBLIC", // Accept feedType prop with default "PUBLIC"
  onLike,
  onSave,
  onComment,
  onShare,
  autoOpenLikes,
}) => {
  // Hide repost functionality for PRIME feed only
  const hideRepost = feedType === "PRIME";
  
  const [showLikesModal, setShowLikesModal] = useState(false);
  const [likesList, setLikesList] = useState([]);
  const [likesLoading, setLikesLoading] = useState(false);
  const navigate = useNavigate();
  const [isShowShareModel, setIsShowShareModel] = useState(false);
  const [isShareList, setIsShareList] = useState([]);
  const [shareLoading, setShareLoading] = useState(false);
  // const actualPost = post?.type === "REPOST" ? post.post : post;
  // // const actualPost = post?.post || post;
  // const postId = post?.post?._id || post?._id;
  // const isSaved = post?.post?.isSaved ?? post?.isSaved;

  const actualPost = post?.post || post;
  const postId = actualPost?._id;
  const isSaved = actualPost?.isSaved;
  const [isEmpty, setIsEmpty] = useState("");
  const [sharePage, setSharePage] = useState(1);
  const [hasMoreShare, setHasMoreShare] = useState(true);

  const fetchLikes = async (postId) => {
    if (showLikesModal) {
      setShowLikesModal(false);
      return;
    }
    try {
      setShowLikesModal(true);
      setLikesLoading(true);
      const res = await api.get(`/likes/${postId}`);
      setLikesList(res.data?.users || []);
    } catch (err) {
      setLikesList([]);
      console.log("Failed to fetch likes list", err);
    } finally {
      setIsEmpty(likesList.length === 0 ? "No likes yet" : "");
      setLikesLoading(false);
    }
  };

  const fetchShare = async (postId, page = 1) => {
    // Don't fetch if repost is hidden
    if (hideRepost) return;
    
    try {
      if (page === 1) {
        setIsShareList([]);
        setHasMoreShare(true);
        setIsShowShareModel(true);
      }

      setShareLoading(true);
      const res = await api.get(
        `feeds/${postId}/reposted-by?page=${page}&limit=10`,
      );
      const newShares = res.data?.users || [];
      setIsShareList((prev) => [...prev, ...newShares]);
      if (newShares.length < 10) {
        setHasMoreShare(false);
      }
      setSharePage(page);
    } catch (err) {
      console.log("Failed to fetch share list", err);
      setShareLoading(false);
    } finally {
      setIsEmpty(isShareList.length === 0 ? "No shares yet" : "");
      setShareLoading(false);
    }
  };

  const loadMoreShares = () => {
    if (!hasMoreShare || shareLoading || hideRepost) return;
    const nextPage = sharePage + 1;
    setSharePage(nextPage);
    fetchShare(post._id, nextPage);
  };

  const openUserProfile = (userId) => {
    setShowLikesModal(false);
    setIsShowShareModel(false);
    navigate(`/user/${userId}/profile`);
  };

  return (
    <div className="post-footer">
      <div className="post-footer-icon row row-col-3">
        <span
          id={`like-btn-${post._id}`}
          className="col d-flex align-items-center gap-1 position-relative"
        >
          <FontAwesomeIcon
            icon={post?.isLiked ? faHeart : faHeartRegular}
            className={post?.isLiked ? "text-danger" : ""}
            onClick={() => onLike(post?._id)}
            style={{ cursor: "pointer" }}
          />
          <span 
            onClick={() => fetchLikes(post?._id)}
            style={{ cursor: "pointer" }}
          >
            {post?.likesCount}
          </span>

          <UserListModel
            isOpen={showLikesModal}
            userList={likesList}
            loading={likesLoading}
            title="Liked by"
            onClose={() => setShowLikesModal(false)}
            onUserClick={(userId) => openUserProfile(userId)}
            emptyMessage={isEmpty}
          />
        </span>

        <span className="col">
          <Icon
            icon="ic:outline-mode-comment"
            onClick={() => onComment(post)}
            style={{ cursor: "pointer" }}
          />{" "}
          {post?.commentsCount}
        </span>

        {/* Share Button Section */}
        <span className="col cursor-pointer">
          {/* External Share Button - Always Visible */}
          <FontAwesomeIcon 
            icon={faShare} 
            onClick={() => onShare(post)}
            style={{ cursor: "pointer", marginRight: "8px" }}
          />
          
          {/* Repost Count - Only show for PUBLIC feed (not PRIME) */}
          {!hideRepost && (
            <span 
              onClick={() => fetchShare(post._id)}
              style={{ cursor: "pointer" }}
            >
              {post?.repostsCount || 0}
            </span>
          )}
        </span>
      </div>

      {/* <div className="post-footer-save-icon">
        <span onClick={() => onSave(actualPost?._id)}>
          <FontAwesomeIcon
            icon={actualPost?.isSaved ? faBookmark : faBookmarkRegular}
            className={actualPost?.isSaved ? "text-danger" : ""}
            style={{ cursor: "pointer" }}
          />

          {!hideRepost && (
            <UserListModel
              isOpen={isShowShareModel}
              userList={isShareList}
              loading={shareLoading}
              title="Shared By"
              onClose={() => setIsShowShareModel(false)}
              onUserClick={(userId) => openUserProfile(userId)}
              hasMore={hasMoreShare}
              onLoadMore={loadMoreShares}
              emptyMessage={isEmpty}
            />
          )}
        </span>
      </div> */}
    </div>
  );
};

export default PostFooter;